import { atom } from 'recoil';

export const userInfoState = atom({
  key: 'memberInfoState',
  default: {
    userId: '',
    userName: '',
    siteNumber: '',
    subsidiaryCompanyCode: '',
    loginType: '',
    memberNumber: '',
    adultCertificationDate: '',
    employNumber: '',
    mileageFlag: true,
  },
});

export const recentlyViewedGoodListState = atom({
  key: 'recentlyViewedGoodListState',
  default: null,
});
